export class DataHelper {
  public static makeUUID = (): string => crypto.randomUUID();
}